import config from '../../config';

const FLOOR_HEIGHT = 1024;
const TILE_PATTERN = [
  'tile-01-loop.jpg',
  'tile-01-loop.jpg',
  'tile-02-transition.jpg',
  'tile-02-loop.jpg',
  'tile-02-loop.jpg',
  'tile-03-transition.jpg',
  'tile-03-loop.jpg',
  'tile-03-loop.jpg',
  'tile-04-transition.jpg',
  'tile-04-loop.jpg',
  'tile-04-loop.jpg',
  'tile-01-transition.jpg'
];

const BEAMS = [
  'beam1.png',
  'beam2.png',
  'brace1.png',
  'brace2.png',
  'i-beam.png',
  'pipe1.png',
  'pipe2.png',
  'pipe3.png'
];

const BEAM_HEIGHT = 350;
const BEAM_SCROLL_RATIO = 1.175;

const xTextOffset = -54;
const yTextOffset = -100;

class Elevator {
  constructor (gameContext) {
    this.g = gameContext;

    this.active = false;
    this.tiles = [];
    this.speed = 0;
    this.targetSpeed = 0;
    this.smoothSpeed = 0;
    this.speedEase = 100;
    this.updateDoorPosition = false;
    this.patternIndex = 0;
    this.beams = [];
    this.beamPool = [];

    this.setTiles(2);

    this.setBeams(4);
    this.updateBeamPositions();

    // console.log('Constructor', this);
  }

  setSpeed (speed) {
    // console.log('Elevator.setSpeed', speed);
    this.targetSpeed = speed;
  }

  setTiles (count) {
    let g = this.g;

    for (let i = 0; i < count; i++) {
      let y = config.CENTER_Y - i * FLOOR_HEIGHT;
      let frame = this.getTileFrame();
      let t = g.add.sprite(config.CENTER_X, y, 'elevator');
      t.setFrame(frame);
      t.originY = y;
      this.tiles.push(t);
    }

    this.door = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'elevator');
    this.door.setFrame('tile-00-elevator.png', false, false);
    this.door.originY = config.CENTER_Y;

    this.doorText = g.add.bitmapText(this.door.x + xTextOffset, this.door.y + yTextOffset, 'elevator-door', g.floorText, 100);
    this.doorText.setAlpha(0.5);
    this.doorText.setOrigin(0.5);
  }

  setBeams (count) {
    let g = this.g;
    for (let i = 0; i < count; i++) {
      let y = config.CENTER_Y - i * BEAM_HEIGHT;
      let frame = this.getBeamFrame();
      let b = g.add.sprite(config.CENTER_X, y, 'elevator');
      b.setFrame(frame);
      b.originY = y;
      this.beams.push(b);
    }
  }

  updateTilePositions () {
    let g = this.g;
    let levelData = g.levelData;
    _.each(this.tiles, (t) => {
      t.setY(t.originY - levelData.scrollPosition);
      if (t.y - FLOOR_HEIGHT / 2 > config.HEIGHT) {
        t.originY -= FLOOR_HEIGHT * this.tiles.length;
        t.setFrame(this.getTileFrame(), false, false);
        if (this.updateDoorPosition) {
          this.door.originY = t.originY;
          this.updateDoorPosition = false;
        }
      }
    });
    this.door.setY(this.door.originY - levelData.scrollPosition);
    this.doorText.setY(this.door.y + yTextOffset);
  }

  updateBeamPositions () {
    let g = this.g;
    let levelData = g.levelData;
    _.each(this.beams, (b) => {
      let y = (b.originY - levelData.scrollPosition) * BEAM_SCROLL_RATIO;
      b.setY(y);
      if (b.y - BEAM_HEIGHT / 2 > config.HEIGHT) {
        b.originY -= BEAM_HEIGHT * this.beams.length;
        // b.setFrame(this.getBeamFrame());
        b.setFrame(this.getBeamFrame(), false, false);
      }
    });
  }

  getTileFrame () {
    let frame = TILE_PATTERN[this.patternIndex];
    this.patternIndex = this.patternIndex + 1 < TILE_PATTERN.length ? this.patternIndex + 1 : 0;
    return frame;
  }

  getBeamFrame () {
    if (this.beamPool.length === 0) {
      this.beamPool = _.shuffle(_.clone(BEAMS));
    }
    let frame = this.beamPool.pop();
    return frame;
  }

  queueDoor () {
    let g = this.g;
    this.doorText.setText(g.floorText);
    this.updateDoorPosition = true;
  }

  start () {
    let g = this.g;

    this.active = true;
  }

  update (accuracy) {
    let g = this.g;
    let levelData = g.levelData;

    if (!this.active) {
      return;
    }

    // this.speed -= ((this.speed - this.targetSpeed) / this.speedEase);
    this.speed -= ((this.speed - this.targetSpeed) / this.speedEase) * accuracy;
    this.smoothSpeed = ~~(this.speed * config.ROUND) / config.ROUND;

    // console.log(this.speed);
    // console.log(this.smoothSpeed);
    levelData.scrollPosition -= this.smoothSpeed;

    this.updateTilePositions();
    this.updateBeamPositions();
  }
}

export default Elevator;
